export default __webpack_public_path__ + "static/media/11.4a91e40d.jpg";